import { Typography } from "@mui/material";
import { TypographyProps } from "./typography-props";


export default function H3({children, ...props}: TypographyProps) {
  return <Typography variant="h3" {...props}>{children}</Typography>
}